import React, { useState } from 'react';
import './NewContact.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import TikTokIcon from '../../TikTokIcon/TikTokIcon';

export default function NewContact() {
    const [mensaje, setMensaje] = useState('');
    const [nombre, setNombre] = useState('');
    const [ruc, setRuc] = useState('');
    const [representante, setRepresentante] = useState('');
    const [telefono, setTelefono] = useState('');
    const [instagram, setInstagram] = useState('');
    const [email, setEmail] = useState('');
    const [direccion, setDireccion] = useState('');
    const [facebook, setFacebook] = useState('');
    const [tiktok, setTiktok] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => {
        setNombre('');
        setRuc('');
        setRepresentante('');
        setTelefono('');
        setInstagram('');
        setEmail('');
        setDireccion('');
        setFacebook('');
        setTiktok('');
        setMensaje('');
        setModalOpen(!modalOpen);
    };

    const crear = async () => {
        const formData = new FormData();
        formData.append('nombre', nombre);
        formData.append('ruc', ruc);
        formData.append('representante', representante);
        formData.append('telefono', telefono);
        formData.append('instagram', instagram);
        formData.append('email', email);
        formData.append('direccion', direccion);
        formData.append('facebook', facebook);
        formData.append('tiktok', tiktok);

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/contactoPost.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>+</span> Agregar
            </button>
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBack'>
                            <h4>Agregar Contacto</h4>
                            <span className='close' onClick={toggleModal}>
                                &times;
                            </span>
                        </div>
                        <form className='sectiontext' onSubmit={(e) => e.preventDefault()}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        type='text'
                                        name='nombre'
                                        placeholder='Nombre del contacto / centro'
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>RUC</legend>
                                    <input
                                        type='text'
                                        name='ruc'
                                        placeholder='Número de RUC (11 dígitos)'
                                        value={ruc}
                                        onChange={(e) => setRuc(e.target.value)}
                                        maxLength={11}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Representante</legend>
                                    <input
                                        type='text'
                                        name='representante'
                                        placeholder='Nombre del representante'
                                        value={representante}
                                        onChange={(e) => setRepresentante(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Teléfono</legend>
                                    <input
                                        type='text'
                                        name='telefono'
                                        placeholder='Número de teléfono o WhatsApp'
                                        value={telefono}
                                        onChange={(e) => setTelefono(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Email</legend>
                                    <input
                                        type='email'
                                        name='email'
                                        placeholder='correo@ejemplo.com'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Dirección</legend>
                                    <input
                                        type='text'
                                        name='direccion'
                                        placeholder='Dirección física'
                                        value={direccion}
                                        onChange={(e) => setDireccion(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Facebook</legend>
                                    <input
                                        type='text'
                                        name='facebook'
                                        placeholder='https://www.facebook.com/tu_pagina'
                                        value={facebook}
                                        onChange={(e) => setFacebook(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Instagram</legend>
                                    <input
                                        type='url'
                                        name='instagram'
                                        placeholder='https://www.instagram.com/tu_cuenta'
                                        value={instagram}
                                        onChange={(e) => setInstagram(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset style={{ width: '100%' }}>
                                    <legend>
                                        <TikTokIcon size={13} style={{ marginRight: 5 }} /> TikTok
                                    </legend>
                                    <input
                                        type='text'
                                        name='tiktok'
                                        placeholder='https://www.tiktok.com/@tu_cuenta'
                                        value={tiktok}
                                        onChange={(e) => setTiktok(e.target.value)}
                                    />
                                </fieldset>
                            </div>

                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crear} className='btnPost'>
                                    Guardar Contacto
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
